// tslint:disable:max-line-length

import React from 'react';

export const ChartPercentBarOutline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <path d="M3,1v7.7H1V1H3 M4,0H0v9.7h4V0L4,0z" />
      <path d="M9,1v2.5H7V1H9 M10,0H6v4.5h4V0L10,0z" />
      <path d="M15,1v5.5h-2V1H15 M16,0h-4v7.5h4V0L16,0z" />
      <rect x="6" y="3" width="4" height="11" />
      <rect y="8" width="4" height="6" />
      <rect x="12" y="5" width="4" height="9" />
    </svg>
  );
};
